import {useEffect} from 'react';

import {useGlobalState} from 'hooks/useGlobalState';
import {useSetGlobalState} from 'hooks/useSetGlobalState';
import {setSelectedHeaderAC} from 'store/header/headerSlice';

import './Header.scss';

interface IProps {
  titles?: string[];
}

const Header = ({titles = []}: IProps) => {
  const dispatch = useSetGlobalState();

  const {selectedHeader} = useGlobalState((state) => state.header);

  const handleSetHeader = (index: number) => dispatch(setSelectedHeaderAC(index));

  useEffect(() => {
    return () => {
      dispatch(setSelectedHeaderAC(0));
    };
  }, [dispatch]);

  return (
    <div className="header" data-testid="header">
      <div role="tablist" aria-label="list of header tabs" className="header__titles">
        {titles.length > 0 && (
          <>
            {titles.map((title, index) => (
              <button
                className={`header__tab ${selectedHeader === index ? 'header__tab--active' : ''}`}
                key={title}
                onClick={() => handleSetHeader(index)}
                role="tab"
                id={title}
              >
                {title}
              </button>
            ))}
          </>
        )}
      </div>
    </div>
  );
};

export default Header;
